const properties ={};

/** Inicio Zuul */
const protocol="https";
const port_zuul="8090";
const host_zuul="mz-services.miraflores.gob.pe";
properties.API_MM=`${protocol}://${host_zuul}:${port_zuul}/api`
/** fin Zuul */

/** Inicio link web */
properties.LINK_WEB="https://www.miraflores.gob.pe/plataforma-digital";
properties.LINK_PHP_PAGOS="https://www.miraflores.gob.pe/plataforma-digital";
/** fin link web */

export default properties;


// WEBPACK FOOTER //
// ./src/store/propertiesprd.js